import { Badge, Icon, Text } from '@lounge-fe/ui-kit'
import { BasketLineDetailsProps } from './types'
import { Price } from './Price'
import { DiscountAllocation } from './DiscountAllocation'
import { useProductBadges } from '../../../../product/components/StandardProductCard/hooks/useProductBadges'
import { useMemo } from 'react'

export const Details = ({
  url,
  isDesktop,
  originalLinePrice,
  finalLinePrice,
  title,
  color,
  size,
  isSet,
  discountAllocations,
  hasOnlyDefaultVariant,
  properties,
  tags,
  allItems,
}: BasketLineDetailsProps) => {
  const { primaryBadge } = useProductBadges({
    badges: [],
    price: finalLinePrice,
    price_compare_at: originalLinePrice,
    tags: tags ?? [],
  })

  const variantDetailsLabel = useMemo(() => {
    if (hasOnlyDefaultVariant) {
      return null
    }
    const hasMultipleSetItems = Boolean(
      isSet && allItems && allItems.length > 1,
    )
    const hasColorAndSize = Boolean(color && size && !hasOnlyDefaultVariant)

    const separator = '\u00B7'

    if (hasMultipleSetItems) {
      const sizesLabel = (allItems || [])
        .map((item) => item.size)
        .filter(Boolean)
        .join(' / ')
      return sizesLabel ? `${color} ${separator} ${sizesLabel}` : color
    }

    if (hasColorAndSize) {
      return `${color} ${separator} ${size}`
    }

    return color || size
  }, [isSet, allItems, color, size, hasOnlyDefaultVariant])

  return (
    <div className="flex flex-col w-full gap-y-1">
      {primaryBadge && (
        <Badge variant="ghost" color={primaryBadge.color} size="sm">
          {primaryBadge.text}
        </Badge>
      )}
      <a href={url}>
        <Text variant="title-six" className="text-base-primary font-regular">
          {title}
        </Text>
      </a>
      <div className="flex flex-col gap-1">
        <Text variant="body-sm" className="text-subtle">
          {variantDetailsLabel}
        </Text>
        <div className="flex items-center justify-between flex-wrap gap-x-2 gap-y-1">
          <Price
            originalLinePrice={originalLinePrice}
            finalLinePrice={finalLinePrice}
          />
          {discountAllocations
            .filter(({ amount }) => amount > 0)
            .map((discountAllocation, idx) => (
              <DiscountAllocation
                key={idx}
                discountAllocation={discountAllocation}
              />
            ))}
        </div>
        {Boolean(properties?.__shopify_send_gift_card_to_recipient) && (
          <>
            <Text
              variant="body-sm"
              className="text-subtle flex gap-x-2 items-center"
            >
              <Icon.Email />
              <span>{properties?.['Recipient email']}</span>
            </Text>
            {properties?.['Send on'] && (
              <Text
                variant="body-sm"
                className="text-subtle flex gap-x-2 items-center"
              >
                <Icon.Calendar />
                <span>
                  {new Date(properties?.['Send on']).toLocaleDateString()}
                </span>
              </Text>
            )}
          </>
        )}
      </div>
    </div>
  )
}
